"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXProxyUserV2Contract = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const VXProxyUserV2ABI_1 = require("./abi/VXProxyUserV2ABI");
class VXProxyUserV2Contract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, VXProxyUserV2ABI_1.VXProxyUserV2ABI.GetABI());
    }
    getBotConfig(ofAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("getBotConfig", ofAddress);
            if (!result)
                return;
            result.swapMaxSlippageIndex = this._toDecimal(result.swapMaxSlippageIndex);
            result.swapFrequencySeconds = parseInt(result.swapFrequencySeconds);
            result.splitFrequencySeconds = parseInt(result.splitFrequencySeconds);
            result.splitMinProfitAmount = this._toDecimal(result.splitMinProfitAmount);
            result.maxGasAmount = this._toDecimal(result.maxGasAmount);
            return result;
        });
    }
}
exports.VXProxyUserV2Contract = VXProxyUserV2Contract;
//# sourceMappingURL=VXProxyUserV2Contract.js.map